import React from "react";
import SearchResult from "../../SearchResult";
import styles from "./headerMobile.scss";
import SortOption from "../../../../components/SortOption";
import FilterSwitch from "../../FilterSwitch";
import { SaveSearchButton } from "../SaveSearchButton";

const HeaderMobile = ({
  loading,
  filters,
  hasSaveButton,
  onSave,
  ads,
  isMobile,
  onToggleFilter,
  onSortClick,
  sortOption
}) => (
  <div className={styles.filterContainer}>
    <div className={styles.sortFilterContainer}>
      <div>
        {!isMobile ? null : (
          <SortOption
            isMobile={isMobile}
            onSortClick={onSortClick}
            selectedOption={sortOption}
          />
        )}
        <FilterSwitch isMobile={isMobile} onToggleFilter={onToggleFilter} />
      </div>
      {!hasSaveButton ? null : (
        <SaveSearchButton onSave={onSave} className={styles.saveSearchButton} />
      )}
    </div>
    {loading
      ? <span className={styles.skeletonLoaderHeading}></span>
      : filters && (
        <SearchResult
          ads={ads}
          // @ts-ignore
          text={filters.text}
          className={styles.searchResult}
        />
      )}


  </div>
);

export default HeaderMobile;



// WEBPACK FOOTER //
// ./src/containers/SearchPage/SearchSection/HeaderMobile/HeaderMobile.tsx